module.exports = __webpack_public_path__ + "static/media/logo.33cedd98.svg";